import React, { useState, useEffect } from 'react'
import Modal from '../../../Components/Cards/Modal'
import OwnerCard from '../../../Components/Cards/OwnerCard'
import Danger from '../../../assets/danger-sign.png'
import api from '../../../services/api'


const ViewUsers = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [seekers, setSeekers] = useState([])

  useEffect(() => {
    document.title = 'Viewing all users'
    api.admin.getAllHomeSeekers().then((res)=>{setSeekers(res.data?.data)}).catch(res=>console.log(res))
  }, [])

  const openModal = () => {
    setIsModalOpen(true);
  };
  return (
    <section className='my-3'>
      <h2 className='text-center font-bold text-3xl text-asparagus-500'>All Home Seekers</h2>
      <div className='displayData'>
        {
          seekers.map((x, y) => {
            return (
              <OwnerCard name={x.firstname + " " + x.lastname} image={x.photo} email={x.email} otherDetail={x.agency_name} key={y} activate={""} type={'owner'} id={x} openModal={openModal} />
            )
          })
        }
      </div>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className='flex flex-col items-center gap-4'>
          <img src={Danger} alt="" className='w-[100px]' />
          <h2 className='text-2xl'>Are you sure you want to delete?</h2>
          <div className='flex  gap-4 items-center'>
            <button type="button" className='bg-asparagus-600 px-4 rounded-md py-1 text-white font-medium'>Yes</button>
            <button type="button" className='bg-red-600 px-4 rounded-md py-1 text-white font-medium' onClick={() => setIsModalOpen(false)}>No</button>
          </div>
        </div>
      </Modal>
    </section>
  )
}

export default ViewUsers